module.exports = __webpack_public_path__ + "img/email.c76022d5.svg";